import React from "react";

const Work = () => {
  return (
    <div className="chhose-book-and-get-container  align-items-center text-center here-top-space home-container">
      <div className="w-100">
        <span className="home-work-heading">Here’s</span>
      </div>
      <div className=" overflow-y-hidden how-it-works-top-space">
        <span className="home-work-title ">How It works</span>
      </div>
      
      <div className="home-work-desc text-center justify-content-center  how-it-works-text-padding">
      With Instacuts you can choose to experience salon services On-Demand or schedule for later at your convenience!
      </div>
      

      <div className="justify-content-center  d-md-flex install-our-app-div margin-0px-under-1439">
        <div className="col-md-12  d-flex justify-content-between align-items-center">
          <hr className="home_work_lines home-dotted-line-bottom" />
          <div className="col-md-3 d-flex justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
              <img
               src="assets/homepage/installOurApp.svg"
               alt=""
               className="install-our-app-div"
               >

              </img>
              {/* <svg
                width="42"
                height="39"
                viewBox="0 0 42 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.5712 8.89087C37.6775 8.89087 41.8337 13.1821 41.8337 18.4564L41.8337 28.9403C41.8337 34.2017 37.6879 38.4821 32.5921 38.4821L9.43374 38.4821C4.32541 38.4821 0.167068 34.1931 0.167068 28.9188L0.167068 18.4348C0.167068 13.1735 4.31499 8.89087 9.4129 8.89087H11.3712L32.5712 8.89087Z"
                  fill="black"
                />
                <path
                  d="M22.1383 28.4114L28.1988 22.2283C28.8238 21.5892 28.8238 20.5608 28.1946 19.9239C27.5654 19.2891 26.5508 19.2912 25.9258 19.9281L22.6071 23.3138L22.6071 1.83787C22.6071 0.938538 21.8883 0.208496 21.0008 0.208496C20.1154 0.208496 19.3988 0.938538 19.3988 1.83787L19.3988 23.3138L16.0779 19.9281C15.4529 19.2912 14.4383 19.2891 13.8092 19.9239C13.4946 20.2434 13.3363 20.6603 13.3363 21.0792C13.3363 21.494 13.4946 21.9109 13.805 22.2283L19.8654 28.4114C20.1675 28.7182 20.5758 28.8918 21.0008 28.8918C21.4279 28.8918 21.8363 28.7182 22.1383 28.4114Z"
                  fill="white"
                />
              </svg> */}
            </div>
          </div>
          <div className="col-md-3 d-flex justify-content-center">
            <div className="d-flex align-items-center justify-content-center ">
            <img
               src="assets/homepage/selectandschedule.svg"
               alt=""
               className="install-our-app-div"
               >

              </img>
              {/* <svg
                width="30"
                height="34"
                viewBox="0 0 30 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.3515 1.61379L22.3531 2.86317C26.9442 3.22299 29.9769 6.35142 29.9819 11.149L30 25.192C30.0065 30.4227 26.7204 33.6411 21.453 33.6494L8.58647 33.6661C3.35199 33.6727 0.0246943 30.3777 0.0181121 25.132L1.10829e-05 11.254C-0.0065711 6.42472 2.91921 3.30461 7.51029 2.88316L7.50864 1.63378C7.50699 0.900816 8.05002 0.349426 8.77407 0.349426C9.49811 0.34776 10.0411 0.897485 10.0428 1.63045L10.0444 2.79653L19.819 2.78321L19.8173 1.61712C19.8157 0.884158 20.3587 0.334433 21.0828 0.332767C21.7903 0.331102 22.3498 0.880826 22.3515 1.61379ZM2.53581 11.7689L27.4494 11.7356V11.1525C27.3786 7.57099 25.5817 5.69193 22.3564 5.41207L22.3581 6.69476C22.3581 7.41107 21.8002 7.97912 21.0926 7.97912C20.3686 7.98078 19.8239 7.4144 19.8239 6.69809L19.8223 5.34877L10.0477 5.36209L10.0494 6.70975C10.0494 7.42773 9.50799 7.99411 8.78395 7.99411C8.05991 7.99578 7.51524 7.43106 7.51524 6.71309L7.51359 5.43039C4.30478 5.7519 2.52923 7.63762 2.53417 11.2508L2.53581 11.7689ZM20.4001 19.3404V19.3587C20.4165 20.125 21.0418 20.7064 21.8004 20.6897C22.5409 20.6714 23.1317 20.0367 23.1152 19.2704C23.0807 18.5375 22.4866 17.9394 21.7478 17.9411C20.9908 17.9578 20.3984 18.5741 20.4001 19.3404ZM21.7588 26.8198C21.0019 26.8032 20.3914 26.1718 20.3897 25.4055C20.3733 24.6393 20.9805 24.0046 21.7374 23.9862H21.7539C22.5273 23.9862 23.1542 24.6176 23.1542 25.4005C23.1559 26.1835 22.5306 26.8182 21.7588 26.8198ZM13.62 19.3665C13.6529 20.1328 14.2799 20.7308 15.0369 20.6975C15.7773 20.6625 16.3681 20.0295 16.3352 19.2632C16.3171 18.5136 15.7082 17.9305 14.9677 17.9322C14.2108 17.9655 13.6184 18.6002 13.62 19.3665ZM15.0434 26.7449C14.2865 26.7782 13.6611 26.1802 13.6266 25.4139C13.6266 24.6476 14.2173 24.0146 14.9743 23.9796C15.7148 23.978 16.3253 24.561 16.3417 25.309C16.3763 26.0769 15.7839 26.7099 15.0434 26.7449ZM6.84066 19.4249C6.87357 20.1912 7.50052 20.7909 8.25747 20.7559C8.99797 20.7226 9.58872 20.0879 9.55416 19.3216C9.53771 18.572 8.92886 17.9889 8.18672 17.9906C7.42976 18.0239 6.83901 18.6586 6.84066 19.4249ZM8.26403 26.7532C7.50707 26.7882 6.88177 26.1885 6.84721 25.4222C6.84556 24.6559 7.43796 24.0212 8.19491 23.9879C8.93541 23.9862 9.54591 24.5693 9.56236 25.3189C9.59692 26.0852 9.00617 26.7199 8.26403 26.7532Z"
                  fill="#130F26"
                />
              </svg> */}
            </div>
          </div>

          <div className="col-md-3 d-flex justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
            <img
               src="assets/homepage/experince.svg"
               alt=""
               className="install-our-app-div"
               >

              </img>
              {/* <svg
                width="34"
                height="32"
                viewBox="0 0 34 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.8645 19.8663C26.4328 20.2846 26.2345 20.8896 26.3328 21.4829L27.8145 29.6829C27.9395 30.3779 27.6461 31.0813 27.0645 31.4829C26.4945 31.8996 25.7361 31.9496 25.1145 31.6163L17.7328 27.7663C17.4761 27.6296 17.1911 27.5563 16.8995 27.5479H16.4478C16.2911 27.5713 16.1378 27.6213 15.9978 27.6979L8.61447 31.5663C8.24947 31.7496 7.83613 31.8146 7.43113 31.7496C6.44447 31.5629 5.78613 30.6229 5.9478 29.6313L7.43113 21.4313C7.52947 20.8329 7.33113 20.2246 6.89947 19.7996L0.881134 13.9663C0.377801 13.4779 0.202801 12.7446 0.432801 12.0829C0.656134 11.4229 1.22613 10.9413 1.91447 10.8329L10.1978 9.63126C10.8278 9.56626 11.3811 9.18293 11.6645 8.61626L15.3145 1.13293C15.4011 0.96626 15.5128 0.812926 15.6478 0.682926L15.7978 0.56626C15.8761 0.479593 15.9661 0.407926 16.0661 0.349593L16.2478 0.282926L16.5311 0.16626H17.2328C17.8595 0.23126 18.4111 0.60626 18.6995 1.16626L22.3978 8.61626C22.6645 9.16126 23.1828 9.53959 23.7811 9.63126L32.0645 10.8329C32.7645 10.9329 33.3495 11.4163 33.5811 12.0829C33.7995 12.7513 33.6111 13.4846 33.0978 13.9663L26.8645 19.8663Z"
                  fill="#130F26"
                />
              </svg> */}
            </div>
          </div>
        </div>
      </div>
      <div className="justify-content-between work-content-desk text-center">
        <div className="row  work-content-desc">
          <div className="col-md-4 top-margin-for-install-our-app ">
            <span className="home-work-icon-title">Install Our App</span>
            <p className="available-to-download-top-space">
              Available to download for IOS, Android or book directly on our
              website by signing up here.
            </p>
          </div>
          <div className="col-md-4 top-margin-for-install-our-app">
            <span className="home-work-icon-title">Select & Schedule</span>
            <p className="available-to-download-top-space">
              Scroll through the curated list of services and book your service
              with our stylist.
            </p>
          </div>
          <div className="col-md-4 top-margin-for-install-our-app">
            <span className="home-work-icon-title">Experience The Best</span>
            <p className="available-to-download-top-space">
            With Instacuts you can choose to experience services On-Demand or schedule for later.
            </p>
          </div>
        </div>
      </div>

     
    </div>
  );
};

export default Work;
